<template>
	<div class="lady" :class="{active}" v-if="data">
		<a class="contact" @click="toggle"><div class="wrap">Kontakt</div></a>
		<div class="meta">
			<div class="image" v-if="data.image"><img :src="data.image.url"/></div>

			<div class="content">
				<a class="exit" @click="toggle" v-html="require('@/assets/icons/cross.svg')"/>

				<div class="name" v-text="data.name"/>

				<div class="info">
					<div>
						<div class="icon" v-html="require('@/assets/icons/phone.svg')"/>
						<a class="link" :href="`tel:${data.phone}`" v-text="data.phone"/>
					</div>
					<div>
						<div class="icon" v-html="require('@/assets/icons/at.svg')"/>
						<a class="link" :href="`mailto:${data.email}`" v-text="data.email"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			active: !localStorage.getItem("lady")
		}
	},
	computed: {
		data: (t) => t.$store.getters["user/employee"]
	},
	methods: {
		toggle() {
			this.active = !this.active;

			if (!this.active) {
				localStorage.setItem("lady", true);
			}
		}
	}
}
</script>

<style lang="scss" scoped>
$bookmark: 40px;

.lady {
	position: fixed;
	top: 32vh;
	right: 0;
	height: 173px;
	display: flex;
	transform: translateX(455px);
	transition: cubic(transform, 0.4s);
	box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.25), inset 0 1px 3px 0 rgba(0, 0, 0, 0.5), inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);

	@include res(mobile) {
		display: none;
		transform: translateX(250px);
	}

	&.active {
		transform: translateX(0);
	}

	.contact {
		display: block;
		width: $bookmark;

		.wrap {
			font-size: 16px;
			font-weight: 300;
			text-transform: uppercase;
			background-color: #22313A;
			transform: rotate(90deg) translateY(-100%);
			transform-origin: left top 0;
			display: flex;
			align-items: center;
			justify-content: center;
			height: $bookmark;
			width: 173px;
			color: $white1;
		}
	}

	.meta {
		display: flex;
		@include res(mobile) {
			flex-direction: column;
		}
	}

	.image {
		width: 205px;

		@include res(mobile) {
			display: none;
		}

		img {
			height: 100%;
			width: 100%;
			object-fit: cover;
		}
	}

	.content {
		position: relative;
		background-color: $white1;
		padding: 27px 18px;
		padding-right: 38px;
		width: 250px;
		height: 173px;

		.exit {
			position: absolute;
			right: 16px;
			top: 16px;

			/deep/ svg {
				width: 24px;
				height: 24px;
			}
		}

		.name {
			font-weight: 500;
			margin-bottom: 2em;
		}

		.info {
			> div {
				display: flex;
				align-items: center;

				&:first-child {
					margin-bottom: 0.75em;
				}
			}

			.icon {
				display: inline-flex;
				margin-right: 1em;

				/deep/ svg {
					$s: 16px;
					width: $s;
					height: $s;

					path {
						fill: #4A4A4A;
					}
				}
			}
			.link {
				font-weight: 300;
				letter-spacing: 0.08px;
				font-size: 15px;
				color: #B1B1B1;
			}
		}
	}
}
</style>
